import { get } from './client';
import { CatalogueCategory } from '../../models/services/api/getCatalogue';
import { log } from '@domgen/shared/utils/log';

export const getCatalogue = async (): Promise<CatalogueCategory[]> => {
  const brandCode = import.meta.env.VITE_BRAND_CODE;
  try {
    return await get<CatalogueCategory[]>(`/catalogue?brandCode=${brandCode}`);
  } catch (err) {
    log.error({ message: 'Fetch error', data: err });
    throw err;
  }
};
